var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.expedientProfitabilityDetailGetter &&
    Object.keys(_vm.expedientProfitabilityDetailGetter).length
    ? _c(
        "div",
        { staticClass: "profitability-dialog-container" },
        [
          _c("CustomDialogHeaderComponent", {
            attrs: { headerTitle: _vm.texts.title },
          }),
          _c(
            "div",
            { staticClass: "body-container" },
            [
              _c(
                "div",
                { staticClass: "profitability-tables-container" },
                _vm._l(
                  _vm.expedientProfitabilityDetailGetter.tables,
                  function (table) {
                    return _c("HTMLTableComponent", {
                      key: table.name,
                      attrs: { tableData: table },
                    })
                  }
                ),
                1
              ),
              _c("GlobalVisionProfitabilitySummaryFormulaComponent", {
                attrs: { summary: _vm.summary },
              }),
            ],
            1
          ),
          _c("CustomDialogActionButtonsComponent", {
            attrs: { secondaryButtonText: _vm.texts.buttonText },
          }),
        ],
        1
      )
    : _c("SpinnerLayerComponent", { staticClass: "spinner-layer-component" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }